const roleMessages = {
  'notRole.title': 'このページを表示する権限がありません',
  'notRole.button': 'Topページに戻る',
  'role.select.default': '権限で絞り込み(デフォルト:全権限)',
};

export default roleMessages;
